<!-- 时间插件 -->
<template>
  <div class="DatePicker">
    <div class="date-picker-box">
      <div class="picker-box-inner">
        <el-date-picker
          :clearable="false"
          v-model="date"
          type="date"
          @change="changeDatetime(true)"
          class="date-picker"
          size="small"
          value-format="yyyy-MM-dd"
          :append-to-body='false'
          :picker-options="pickerOptions"
        ></el-date-picker>
        <i class="icon-caret-top" @click="dateOperation(1)"></i>
        <i class="icon-caret-bottom" @click="dateOperation(-1)"></i>
      </div>
      <div class="time-picker-box" v-if="hourOptions.length > 0">
        <div class="picker-box-inner">
          <el-select
            size="small"
            class="select-box"
            v-model="hour"
            @change="changeDatetime(true)"
            @visible-change="visibleHour"
            :popper-append-to-body="false"
          >
            <el-option
              v-for="item in hourOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
          <i class="icon-caret-top" @click="hourOperation(1)"></i>
          <i class="icon-caret-bottom" @click="hourOperation(-1)"></i>
        </div>
      </div>
      <div class="time-picker-box" size="small" v-if="minuteOptions.length > 0">
        <div class="picker-box-inner">
          <el-select
            size="small"
            class="select-box"
            v-model="minute"
            :popper-append-to-body="false"
            @change="changeDatetime"
            @visible-change="visibleMinute"
          >
            <el-option
              v-for="item in minuteOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              :disabled="item.disabled"
            ></el-option>
          </el-select>
          <i class="icon-caret-top" @click="minuteOperation(1)"></i>
          <i class="icon-caret-bottom" @click="minuteOperation(-1)"></i>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      date: '',
      hour: '00',
      minute: '00',
      hourOptions: [],
      minuteOptions: [],
      initDatetime: '',
      pickerOptions: {
        disabledDate: (time) => {
          if (this.DatetimeRange && this.DatetimeRange.length > 0) {
            const startDatetime = new Date(
              new Date(this.DatetimeRange[0]).toLocaleDateString()
            ).getTime()
            const endDatetime = new Date(this.DatetimeRange[1]).getTime()
            return time.getTime() < startDatetime || time.getTime() > endDatetime
          } else {
            return false
          }
        }
      },
      trigger: '' // 没有改变这个值，不会触发改变时间事件
    }
  },
  props: {
    interval: {
      type: Number,
      default: 1
    },
    delayTime: Number,
    startHour: Number,
    startMinute: Number,
    DatetimeRange: Array
  },
  watch: {
    trigger () {
      this.changeDatetime()
    }
  },
  methods: {
    changeDatetime (flag = false) {
      if (this.date === '' || this.hour === '' || this.minute === '') {
        return
      }
      const datetime = `${this.date} ${this.hour}:${this.minute}:00`
      if (flag && this.DatetimeRange && this.DatetimeRange.length > 0) {
        const startDatetime = new Date(this.DatetimeRange[0]).getTime()
        const endDatetime = new Date(this.DatetimeRange[1]).getTime()
        let current = new Date(datetime).getTime()
        if (current < startDatetime || current > endDatetime) {
          this.minute = ''
          current = new Date(`${this.date} ${this.hour}:00:00`).getTime()
          if (current < startDatetime || current > endDatetime) {
            this.hour = ''
          }
        } else {
          this.$emit('callback', datetime)
        }
      } else {
        this.$emit('callback', datetime)
      }
    },
    formatDatetime (date, fmt) {
      const o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'H+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds() // 毫秒
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + '').substr(4 - RegExp.$1.length)
        )
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length === 1
              ? o[k]
              : ('00' + o[k]).substr(('' + o[k]).length)
          )
        }
      }
      return fmt
    },
    changeDateTime (time) {
      this.date = this.formatDatetime(time, 'yyyy-MM-dd')
      this.hour = this.formatDatetime(time, 'HH')
    },
    /**
     * 默认时间
     */
    defalutDateTime () {
      const _this = this
      let delayTime = 0
      if (_this.delayTime) {
        delayTime = _this.delayTime
      }
      const timestamp = new Date().getTime() - delayTime * 6e4
      let datetime = new Date(timestamp - (timestamp % (_this.interval * 6e4)))
      // 小时
      let flag = true
      const hour = _this.formatDatetime(datetime, 'HH')
      let hourIndex = _this.hourOptions.findIndex(
        (item) => Number.parseInt(item.value) === Number.parseInt(hour)
      )
      if (hourIndex === -1) {
        hourIndex = _this.hourOptions.findIndex(
          (item) => Number.parseInt(item.value) > Number.parseInt(hour)
        )
        if (_this.hourOptions.length > 0) {
          if (hourIndex === 0) {
            datetime = new Date(datetime.getTime() - 8.64e7)
            _this.hour = _this.hourOptions[_this.hourOptions.length - 1].value
            _this.minute =
              _this.minuteOptions[_this.minuteOptions.length - 1].value
            flag = false
          } else {
            _this.hour = _this.hourOptions[hourIndex - 1].value
          }
        }
      } else {
        _this.hour = hour
      }
      // 分钟
      if (flag) {
        const minute = _this.formatDatetime(datetime, 'mm')
        let minuteIndex = _this.minuteOptions.findIndex(
          (item) => Number.parseInt(item.value) === Number.parseInt(minute)
        )
        if (minuteIndex === -1) {
          minuteIndex = _this.minuteOptions.findIndex(
            (item) => Number.parseInt(item.value) > Number.parseInt(minute)
          )
          if (_this.minuteOptions.length > 0) {
            if (minuteIndex === 0) {
              datetime = new Date(datetime.getTime() - 3.6e6)
              _this.minute =
                _this.minuteOptions[_this.minuteOptions.length - 1].value
            } else {
              _this.minute = _this.minuteOptions[minuteIndex - 1].value
            }
          }
        } else {
          _this.minute = minute
        }
      }
      // 日期
      _this.date = _this.formatDatetime(datetime, 'yyyy-MM-dd')
      _this.initDatetime = datetime
      _this.trigger = Math.random()
    },
    /**
     * 创建时间选项
     */
    createDatetimeOptions () {
      const _this = this
      const dayToMinute = 1440
      if (_this.interval % dayToMinute === 0) {
        return
      }
      // 小时
      const [hourToMinute, hourLength, minuteLength] = [60, 24, 60]
      let intervalHour = 1
      if (_this.interval % hourToMinute === 0) {
        intervalHour = _this.interval / hourToMinute
      }
      let startHour = 0
      if (_this.startHour) {
        startHour = _this.startHour
      }
      for (let num = startHour; num < hourLength; num += intervalHour) {
        const value = num > 9 ? `${num}` : `0${num}`
        _this.hourOptions.push({
          value: value,
          label: value,
          disabled: false
        })
      }
      // 分钟
      if (_this.interval % hourToMinute !== 0) {
        const intervalMinute = _this.interval % hourToMinute
        let startMinute = 0
        if (_this.startMinute) {
          startMinute = _this.startMinute
        }
        for (let num = startMinute; num < minuteLength; num += intervalMinute) {
          const value = num > 9 ? `${num}` : `0${num}`
          _this.minuteOptions.push({
            value: value,
            label: value,
            disabled: false
          })
        }
      }
    },
    /**
     * 日期运算
     */
    dateOperation (num, flag = true) {
      const _this = this
      let datetime =
        new Date(
          `${this.date} ${this.hour === '' ? '00' : this.hour}:${this.minute === '' ? '00' : this.minute
          }:00`
        ).getTime() +
        num * 8.64e7
      let bool = _this.effectiveRange(datetime, flag)
      if (!bool) {
        datetime = datetime - Number(_this.minute) * 6e4
        bool = _this.effectiveRange(datetime, false)
        if (bool) {
          _this.minute = ''
        } else {
          datetime = datetime - Number(_this.hour) * 3.6e6
          bool = _this.effectiveRange(datetime, false)
          if (bool) {
            _this.hour = ''
            _this.minute = ''
          } else {
            this.$message({
              message: '超出限制范围。',
              type: 'warning',
              duration: 1500
            })
          }
        }
      }
    },
    /**
     * 小时运算
     */
    hourOperation (num, flag = true) {
      const _this = this
      if (this.date === '' || this.hour === '' || this.minute === '') {
        return
      }
      let index = _this.hourOptions.findIndex(
        (item) => item.value === _this.hour
      )
      index += num
      let datetime
      if (index < 0) {
        datetime =
          new Date(
            `${_this.date} ${_this.hourOptions[_this.hourOptions.length - 1].value
            }:${_this.minute}:00`
          ).getTime() - 8.64e7
      } else if (index >= _this.hourOptions.length) {
        datetime =
          new Date(
            `${_this.date} ${_this.hourOptions[0].value}:${_this.minute}:00`
          ).getTime() + 8.64e7
      } else {
        datetime = new Date(
          `${_this.date} ${_this.hourOptions[index].value}:${_this.minute}:00`
        ).getTime()
      }
      let bool = _this.effectiveRange(datetime, flag)
      if (!bool) {
        datetime = datetime - Number(_this.minute) * 6e4
        bool = _this.effectiveRange(datetime, false)
        if (bool) {
          _this.minute = ''
        } else {
          this.$message({
            message: '超出限制范围。',
            type: 'warning',
            duration: 1500
          })
        }
      }
    },
    /**
     * 分钟运算
     */
    minuteOperation (num, flag = true) {
      const _this = this
      if (this.date === '' || this.hour === '' || this.minute === '') {
        return
      }
      let index = _this.minuteOptions.findIndex(
        (item) => item.value === _this.minute
      )
      index += num
      let datetime
      if (index < 0) {
        index = _this.minuteOptions.length - 1
        datetime =
          new Date(
            `${_this.date} ${_this.hour}:${_this.minuteOptions[index].value}:00`
          ).getTime() - 3.6e6
      } else if (index >= _this.minuteOptions.length) {
        index = 0
        datetime =
          new Date(
            `${_this.date} ${_this.hour}:${_this.minuteOptions[index].value}:00`
          ).getTime() + 3.6e6
      } else {
        datetime = new Date(
          `${_this.date} ${_this.hour}:${_this.minuteOptions[index].value}:00`
        ).getTime()
      }
      const bool = _this.effectiveRange(datetime, flag)
      if (!bool) {
        this.$message({
          message: '超出限制范围。',
          type: 'warning',
          duration: 1500
        })
      }
    },
    /**
     * 判断选择的时间是否在有效范围内
     */
    effectiveRange (datetime, flag) {
      const _this = this
      let bool = true
      if (_this.DatetimeRange && _this.DatetimeRange.length > 0) {
        const sDate = _this.DatetimeRange[0]
        const eDate = _this.DatetimeRange[1]
        let startDatetime = sDate ? new Date(sDate).getTime() : -1
        const endDatetime = eDate ? new Date(eDate).getTime() : -1
        if (sDate && _this.minute === '') {
          startDatetime = new Date(
            `${_this.formatDatetime(new Date(sDate), 'yyyy-MM-dd HH')}:00:00`
          ).getTime()
        }
        if (sDate && _this.hour === '') {
          startDatetime = new Date(
            `${_this.formatDatetime(new Date(sDate), 'yyyy-MM-dd')} 00:00:00`
          ).getTime()
        }
        const sFlag = startDatetime === -1 ? true : datetime >= startDatetime
        const eFlag = endDatetime === -1 ? true : datetime <= endDatetime
        if (!sFlag || !eFlag) {
          bool = false
        }
      }
      if (bool) {
        const dt = new Date(datetime)
        const date = _this.formatDatetime(dt, 'yyyy-MM-dd')
        if (_this.date !== date && _this.date !== '') {
          _this.date = date
        }
        const hour = _this.formatDatetime(dt, 'HH')
        if (_this.hour !== hour && _this.hour !== '') {
          _this.hour = hour
        }
        const minute = _this.formatDatetime(dt, 'mm')
        if (_this.minute !== minute && _this.minute !== '') {
          _this.minute = minute
        }
        if (flag) {
          _this.trigger = Math.random()
        }
      }
      return bool
    },
    /**
     * 禁用超过时间范围的选项(分钟选项)
     */
    visibleMinute (flag) {
      const _this = this
      if (flag && _this.DatetimeRange && _this.DatetimeRange.length > 0) {
        const startDatetime = _this.DatetimeRange[0]
          ? new Date(_this.DatetimeRange[0]).getTime()
          : -1
        const endDatetime = _this.DatetimeRange[1]
          ? new Date(_this.DatetimeRange[1]).getTime()
          : -1
        _this.minuteOptions.forEach((item) => {
          const current = new Date(
            `${_this.date} ${_this.hour}:${item.value}:00`
          ).getTime()
          const startFlag =
            startDatetime === -1 ? false : current < startDatetime
          const endFlag = endDatetime === -1 ? false : current > endDatetime
          if (startFlag || endFlag || _this.hour === '') {
            item.disabled = true
          } else {
            item.disabled = false
          }
        })
      }
    },
    /**
     * 禁用超过时间范围的选项
     */
    visibleHour (flag) {
      const _this = this
      if (flag && _this.DatetimeRange && _this.DatetimeRange.length > 0) {
        const startDatetime = _this.DatetimeRange[0]
          ? new Date(_this.DatetimeRange[0]).getTime() - 3.6e6
          : -1
        const endDatetime = _this.DatetimeRange[1]
          ? new Date(_this.DatetimeRange[1]).getTime()
          : -1
        _this.hourOptions.forEach((item) => {
          const current = new Date(
            `${_this.date} ${item.value}:00:00`
          ).getTime()
          const startFlag =
            startDatetime === -1 ? false : current < startDatetime
          const endFlag = endDatetime === -1 ? false : current > endDatetime
          if (startFlag || endFlag) {
            item.disabled = true
          } else {
            item.disabled = false
          }
        })
      }
    },
    /**
     * 通过传参方式改变时间
     */
    changeDatetimeByParam (datetime, flag = true) {
      const _this = this
      _this.date = _this.formatDatetime(datetime, 'yyyy-MM-dd')
      _this.hour = _this.formatDatetime(datetime, 'HH')
      _this.minute = _this.formatDatetime(datetime, 'mm')
      if (flag) {
        _this.trigger = Math.random()
      }
    }
  },
  mounted () {
    const _this = this
    _this.createDatetimeOptions()
    _this.defalutDateTime()
  }
}
</script>
<style scoped>
.DatePicker {
  font-size: 12px;
  display: flex;
}
.DatePicker .date-picker-box,
.DatePicker .time-picker-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.DatePicker .date-picker-box {
  background: #5592CB;
  border: 1px solid #5592CB;
  border-radius: 0.25rem;
  padding: 0 .5rem;
}
.DatePicker .picker-box-inner .date-picker {
  width: 7.2em;
}
.DatePicker .time-picker-box .picker-box-inner {
  /*margin-left: 0.7em;*/
}
.DatePicker .picker-box-inner {
  /*border: 1px solid #fff;*/
  position: relative;
  border-radius: 5px;
  padding: 0;
  margin: 0;
  padding-right: 1.3em;
  display: flex;
  /*margin-right: 0.7em;*/
}
.DatePicker .picker-box-inner .select-box {
  width: 2.4em;
}
.icon-caret-top {
  position: absolute;
  top: 0.6em;
  right: 0.3em;
  border-right: 0.5em solid transparent;
  border-left: 0.5em solid transparent;
  border-bottom: 0.5em solid #fff;
}
.icon-caret-bottom {
  position: absolute;
  top: 1.4em;
  right: 0.3em;
  border-right: 0.5em solid transparent;
  border-left: 0.5em solid transparent;
  border-top: 0.5em solid #fff;
}
.icon-caret-top,
.icon-caret-bottom {
  cursor: pointer;
}
</style>
<style>
.DatePicker .el-input__prefix {
  left: auto;
  right: 0px;
  color: #fff;
}
.DatePicker .el-input--suffix .el-input__inner {
  padding-left: 5px;
  border: 0;
}
.DatePicker .date-picker-box .el-input--suffix .el-input__inner {
  padding-right: 15px;
}
.DatePicker .time-picker-box .el-input--suffix .el-input__inner {
  padding-right: 5px;
}
.DatePicker .el-input__inner {
  background-color: transparent;
  color: #fff;
}
.DatePicker .time-picker-box .el-input__suffix {
  display: none;
}
</style>
